import QuillLocalStorage from 'core/utils/localStorageClient';
import { getReduxStore } from '@Common/redux/store';
import {
  CitationData,
  CitationListAction,
  CitationStylesEnum,
  CitedData,
  ICitationStyle,
} from '../types';
import * as actionNames from '../types/names';

export function addCitationToList(
  editFormDefaultValuse: CitationData,
  indexOfCitaionToBeEdit?: number | null
): CitationListAction {
  return {
    type: actionNames.ADD_CITATION_TO_LIST,
    payload: { editFormDefaultValuse, indexOfCitaionToBeEdit },
  };
}

export function removeCitaionToList(payload: number): CitationListAction {
  return { type: actionNames.REMOVE_CITATION_FROM_LIST, payload };
}

export function changeCitationStyle(payload: CitationStylesEnum | string): CitationListAction {
  QuillLocalStorage.getInstance()?.set(
    `citationStyle${getReduxStore()?.getState()?.common?.partnerCompany}`,
    payload
  );
  return { type: actionNames.USER_CHANGED_CITATION_STYLE, payload };
}

export function removeAllCitaionList(): CitationListAction {
  return { type: actionNames.RemoveAllCitaionList };
}

export function ignoreWarning(index: number): CitationListAction {
  return { type: actionNames.IgnoreWarning, payload: index };
}

export function addCitationsToList(citations: CitationData[]): CitationListAction {
  return {
    type: actionNames.ADD_CITATIONS_TO_LIST,
    payload: citations,
  };
}

export function setCitedData(citedData: CitedData[]): CitationListAction {
  return {
    type: actionNames.SetCitedData,
    payload: citedData,
  };
}

export function updateCitedData(citedData: CitedData[]): CitationListAction {
  return {
    type: actionNames.UpdateCitedData,
    payload: citedData,
  };
}

export function addClonedCitedData(
  oldId: string,
  newId: string,
  citationNumber?: number
): CitationListAction {
  return {
    type: actionNames.AddClonedCitedData,
    payload: {
      oldId,
      newId,
      citationNumber,
    },
  };
}

export function removeCitedData(id: string): CitationListAction {
  return {
    type: actionNames.RemoveCitedData,
    payload: id,
  };
}

export function setCitationStyles(styles: ICitationStyle[]): CitationListAction {
  return {
    type: actionNames.SetCitationStyles,
    payload: styles,
  };
}

export function rebuildCitationNumbers(): CitationListAction {
  return {
    type: actionNames.RebuildCitationNumbers,
  };
}
